import { DEMO_TOKENS, DEMO_USER } from './config.js';
import { driverDemoState } from './store.js';

interface MockOpts {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  body?: unknown;
}

function delay<T>(value: T, ms = 200): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

export async function mockRequest<T>(path: string, opts: MockOpts = {}): Promise<T> {
  const method = opts.method ?? 'GET';
  const route = new URL(path, 'http://demo.local').pathname;
  const body = (opts.body as Record<string, unknown>) ?? {};

  if (route === '/auth/login') {
    return delay({ user: DEMO_USER, ...DEMO_TOKENS } as unknown as T);
  }
  if (route === '/auth/refresh') return delay(DEMO_TOKENS as unknown as T);
  if (route === '/auth/logout') return delay({ ok: true } as unknown as T);
  if (route === '/auth/me') return delay(DEMO_USER as unknown as T);

  if (route === '/drivers/me/status' && method === 'PATCH') {
    const want = body.status === 'online';
    driverDemoState.setStatus(want);
    return delay(
      { id: 'demo-driver-profile-imran', status: want ? 'online' : 'offline', lastSeen: new Date().toISOString() } as unknown as T,
    );
  }
  if (route === '/drivers/me/location' && method === 'POST') {
    return delay({ ok: true } as unknown as T);
  }
  if (route === '/drivers/me/earnings' && method === 'GET') {
    return delay(driverDemoState.earningsSnapshot() as unknown as T);
  }

  if (route === '/trips/history' && method === 'GET') {
    const snap = driverDemoState.earningsSnapshot();
    return delay(
      snap.recent.map((t) => ({
        id: t.id,
        status: 'completed',
        vehicleType: 'economy',
        pickup: { lat: 24.86, lng: 67.01, label: t.pickupLabel },
        drop: { lat: 24.9, lng: 67.08, label: t.dropLabel },
        distanceKm: 0,
        durationMin: 0,
        fare: { base: 150, distance: 0, duration: 0, surge: 0, total: t.fareTotal },
        paymentMethod: 'cash',
      })) as unknown as T,
    );
  }

  const tripMatch = /^\/trips\/([^/]+)$/.exec(route);
  if (tripMatch && method === 'GET') {
    const active = driverDemoState.getActiveTrip();
    if (!active || active.id !== tripMatch[1]) throw new Error('Trip not found.');
    return delay(active as unknown as T);
  }

  throw new Error(`Demo mode: route not mocked yet (${method} ${route}).`);
}
